import { render, staticRenderFns } from "./risk-attendance-table.component.vue?vue&type=template&id=5be3b9a6&scoped=true&"
import script from "./risk-attendance-table.component.vue?vue&type=script&lang=ts&"
export * from "./risk-attendance-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./risk-attendance-table.component.vue?vue&type=style&index=0&id=5be3b9a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be3b9a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
